import DataType from "../../../../../lib/model/types/DataType";
import {createRef} from "react";
import Privilege from "../../../../../lib/model/types/Privilege";
// DataType.getConstrains() wird für onBlur-Validierung genutzt

class BaseFieldGenerator {

  static generateState(privilege) {
    return (privilege & Privilege.ALLOW_EDIT) === 0;
  }

  /**
   * Ermittelt die Constrains für einen fieldType. Standardmässig die serverseitig/clientseitig
   * definierten Constrains (siehe DataType.getConstrains()). Subklassen wie
   * SimpleFilterFieldGenerator überschreiben dies, um z.B. bei Such-/Filterfeldern
   * keine Formular-Validierung (Pflichtfeld etc.) anzuwenden.
   * @param {object} fieldType
   * @returns {ConstrainBase[]}
   */
  computeConstrains(fieldType) {
    return DataType.getConstrains(fieldType);
  }

  initField(fieldType, id, fieldValue, fieldLabel, fieldRef = null, dtoProperties = null, privilege = 65535) {
    if (fieldRef === null) {
      fieldRef = createRef();
    }
    // Constrains für onBlur-Live-Validierung berechnen (per Subklasse überschreibbar,
    // z.B. für Filter-/Suchfelder, die nicht wie Formularfelder validiert werden sollen)
    const constrains = this.computeConstrains(fieldType);

    let field = null;
    switch (fieldType.type) {
      case DataType.BOOLEAN:
        field = this.initBooleanField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        break;
      case DataType.INTEGER:
        field = this.initIntegerField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        break;
      case DataType.FLOAT:
        field = this.initFloatField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        break;
      case DataType.STRING:
        if (fieldType.multiline && !fieldType.isHtml) {
          field = this.initTextAreaField(id, fieldRef, fieldValue, fieldLabel, privilege, fieldType.dataLength, constrains);
        } else if (fieldType.isPassword) {
          field = this.initPasswordField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        } else if (fieldType.isHtml) {
          field = this.initHtmlField(id, fieldRef, fieldValue, fieldLabel, fieldType.valueMap, privilege, constrains);
        } else if (fieldType.isLink) {
          field = this.initLinkField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        } else if (fieldType.isColor) {
          field = this.initColorPickerField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        } else {
          field = this.initTextField(id, fieldRef, fieldValue, fieldLabel, privilege, fieldType.dataLength, constrains);
        }
        break;
      case DataType.DATETIME:
        if (fieldValue !== undefined && fieldValue !== null && fieldValue.length === 19) {
          fieldValue = fieldValue.substring(0, 16);
        }
        field = this.initDateTimePickerField(id, fieldRef, fieldValue, fieldLabel, privilege, fieldType.useTime, constrains);
        break;
      case DataType.ENUM:
        field = this.initEnumField(fieldType, id, fieldRef, fieldValue, fieldLabel, privilege, constrains);
        break;
      case DataType.DATA_EXT:
        field = this.initResourceField(id, fieldRef, fieldValue, fieldLabel, dtoProperties, privilege, constrains);
        break;
      case DataType.OBJECT:
        break;
      default:
        field = this.initTextField(id, fieldRef, fieldValue, fieldLabel, privilege, undefined, constrains);
        break;
    }
    return field;
  }

  initBooleanField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initColorPickerField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>
  }

  initIntegerField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initFloatField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initTextAreaField(id, fieldRef, fieldValue, fieldLabel, privilege, dataLength, constrains) {
    return <div></div>;
  }

  initPasswordField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initHtmlField(id, fieldRef, fieldValue, fieldLabel, valueMap, privilege, constrains) {
    return <div></div>;
  }

  initLinkField(id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initTextField(id, fieldRef, fieldValue, fieldLabel, privilege, maxLength, constrains) {
    return <div></div>;
  }

  initDateTimePickerField(id, fieldRef, fieldValue, fieldLabel, privilege, useTime, constrains) {
    return <div></div>;
  }

  initEnumField(fieldType, id, fieldRef, fieldValue, fieldLabel, privilege, constrains) {
    return <div></div>;
  }

  initResourceField(id, fieldRef, fieldValue, fieldLabel, dtoProperties, privilege, constrains) {
    return <div></div>;
  }
}

export default BaseFieldGenerator;
